import React from 'react'

import Saas from 'saas/react-admin/resources'
import AppState from 'shared/app_state'

export const AccountBilling: React.FC = () => (
  <div style={{ marginTop: '1rem' }}>
    <Saas.StripeBilling accountId={AppState.getCurrentAccount()?.id} />
  </div>
)
